'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	baseUrl: 'https://api.particle.io',
	clientSecret: 'particle-api',
	clientId: 'particle-api',
	tokenDuration: 7776000, // 90 days
	auth: undefined
};
module.exports = exports['default'];
//# sourceMappingURL=Defaults.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/particle-api-js/lib/Defaults.js
 ** module id = 232
 ** module chunks = 0
 **/